import { PhoenixActivity } from 'phoenix/domain'
import { Serializable } from 'util/domain';

export interface ActivityToken {
	phrase:string,
	tuple?: {
		key:string,
		value:string
	}
}

const DefaultPhoenixActivity:PhoenixActivity = {
	ActivityDate: new Date(0).toISOString(),
	Embedded: {
		ActivityDetail: {
			AppName: '',
			FriendlyAppName: '',
			IpAddress:'',
			UserAgent:''
		}
	},
	UserName:'',
	Message:'',
	ConciseMessage:''
};

export class Activity extends Serializable<PhoenixActivity>{
	public details = {
		appName: '',
		friendlyAppName: '',
		ip: '',
		userAgent:''	
	}; 

	public activityDate:Date;

	public get userName(): string {
		return this.source.UserName;
	}
	public set userName(val) {
		this.source.UserName = val;
	};
	public get message(): string {
		return this.source.Message;
	}
	public set message(val) {
		this.source.Message = val;
	};
	public get conciseMessage():string {
		return this.source.ConciseMessage;
	}
	public set conciseMessage(val) {
		this.source.ConciseMessage = val;
	};

	public tokens:ActivityToken[] = [];

	constructor(
		source:PhoenixActivity = angular.copy(DefaultPhoenixActivity)
	) {
		super(source);

		let dtoDetails = this.source.Embedded.ActivityDetail;
		if (dtoDetails) {
			this.details = {
				appName: dtoDetails.AppName,
				friendlyAppName: dtoDetails.FriendlyAppName,
				ip: dtoDetails.IpAddress,
				userAgent: dtoDetails.UserAgent
			};
		}
		this.activityDate = new Date(this.source.ActivityDate);
		this.tokens = this.createTokens(this.conciseMessage);
	}

	public toApi(): PhoenixActivity {
		this.source.Embedded.ActivityDetail = {
			AppName: this.details.appName,
			FriendlyAppName: this.details.friendlyAppName,
			IpAddress: this.details.ip,
			UserAgent: this.details.userAgent
		};

		return this.source
	}

	private createTokens(tokenString:string):ActivityToken[] {
		const tokenRegex = /([^[]*)(\[\@(\w*=[^\]]*)\]([^[\/\]]*)\[\/\])?/g; // https://regex101.com/r/Xsf2PQ/2/
		let tokens:ActivityToken[] = [];
		let group;

		while (group = tokenRegex.exec(tokenString)) {
			if (group.index === tokenRegex.lastIndex) {
				tokenRegex.lastIndex++;
			}
			let phrase = group[1].trim(); 	// any words not in token
			let tuple = group[3]; 			// key-value pair of token (optional)
			let tokenPhrase = group[4]; 	// phrase nested inside token (optional)

			if (phrase) {
				tokens.push({
					phrase: phrase,
					tuple: null
				});	
			}
			if (tuple) {
				tuple = tuple.split('=');
				tokens.push({
					phrase: tokenPhrase.trim(),
					tuple: {
						key: tuple[0],
						value: tuple[1]
					}
				});
			}
		}
		return tokens;
	}
}


// WEBPACK FOOTER //
// ./src/sharebase/domain/activity.ts